import { CURRENCY_SYMBOLS } from './currency.constants';

/**
 * Returns the symbol for a given currency code.
 *
 * @param currencyCode - The numeric code for the currency.
 * @returns The symbol for the given currency code.
 */
export function getCurrencySymbol(currencyCode: number): string {
  return CURRENCY_SYMBOLS[currencyCode] || '';
}
